import { whereEq, path } from 'ramda';
import { get } from 'svelte/store';
import { getStores } from '$app/stores';

function hasPermission(resource, action) {
  const { page } = getStores();
  const permissions = path(['data', 'session', 'user', 'permissions'], get(page));

  return permissions.some(whereEq({ resource, action }));
}

export default hasPermission;
